import { fetchApi } from "../../config/fetchConfig";
import { sanitizeErrorForLogging } from "../../utils/utils";

const localStorageEnum = {
    SAFT_ID_TOKEN: "SAFT_ID_TOKEN",
};

const getIdTokenFromStorage = () => {
    return localStorage.getItem(localStorageEnum.SAFT_ID_TOKEN) ?? null;
};

const isToDisplaySoviAiToolbar = async (dispatch, user) => {
    const queriesBody = {
        query: `query{get_organizations_cache_by_user{modules}}`,
    };

    const response = await fetchApi("/graphql", queriesBody, {}, { dispatch, user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            return res?.data?.get_organizations_cache_by_user || [];
        })
        .catch((error) => {
            console.log("Error fetching Sovi AI toolbar data:", sanitizeErrorForLogging(error));
            return [];
        });

    return response?.some((org) => org.modules?.includes("sovi_ai")) || false;
};

export { getIdTokenFromStorage, localStorageEnum, isToDisplaySoviAiToolbar };
